import { useAuthStore } from '@/stores/auth'; // 토큰 관련 함수들을 import (필요한 경우에만 사용)
import axios from '@/api';

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

const fastapi = (
  operation,
  url,
  params,
  success_callback,
  failure_callback,
  options = {},
) => {

  return new Promise(async (resolve, reject) => {

    // const axiosConfig = {
    //   method: method,
    //   url: url,
    //   ...options
    // };
    // if (method === 'get' || method === 'delete') {
    //   axiosConfig.params = params;
    // } else {
    //   axiosConfig.data = params;
    // }

    // console.log('axios 요청 설정:', axiosConfig);
    //
    // try {
    //   const response = await axios(axiosConfig);
    //   console.log('axios 응답:', {
    //     status: response.status,
    //     headers: response.headers,
    //     data: response.data
    //   });
    //
    //   if (success_callback) {
    //     success_callback(response.data);
    //   }
    //   return response.data;
    // } catch (error) {
    //   console.error('axios 에러:', {
    //     config: error.config,
    //     response: error.response
    //   });
    //
    //   if (failure_callback) {
    //     failure_callback(error);
    //   }
    //   throw error;
    // }

    const authStore = useAuthStore();
    const method = operation.toLowerCase();
    // options가 null이거나 undefined일 때를 대비하여 안전하게 처리
    const safeOptions = options || {};
    const headers = {
      ...(safeOptions.headers || {}),
    };

    if (!headers['Content-Type']) {
      headers['Content-Type'] = 'application/json';
    }

    if (!headers['Authorization'] && !safeOptions.skipAuth) {
      const token = authStore.getToken();
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    }

    if (!headers['X-Tenant-ID']) {
      const tenantId = localStorage.getItem('tenantId');
      if (tenantId) {
        headers['X-Tenant-ID'] = tenantId;
      }
    }

    const baseUrl = import.meta.env.VITE_API_SERVER_URL;
    const apiVersion = import.meta.env.VITE_API_VERSION || '/api/v1';
    //console.error('baseUrl:', baseUrl);
    if (baseUrl === undefined) {
      const error = new Error(
        'VITE_API_SERVER_URL is not defined in environment variables',
      );
      console.error(error);
      reject(error);
      return;
    }

    // URL이 이미 /api/v1로 시작하는지 확인하여 중복 방지
    let versionedUrl;
    if (url.startsWith('/api/v1/')) {
      versionedUrl = url; // 이미 /api/v1로 시작하면 그대로 사용
    } else if (url.startsWith('/')) {
      versionedUrl = `${apiVersion}${url}`; // /로 시작하면 /api/v1 추가
    } else {
      versionedUrl = `${apiVersion}/${url}`; // 그 외의 경우 /api/v1/ 추가
    }
    
    // baseUrl이 비어있으면 상대 경로 사용 (nginx 프록시를 통해)
    const fullUrl = baseUrl 
      ? new URL(versionedUrl, baseUrl)
      : new URL(versionedUrl, window.location.origin);
    console.info('fullUrl:', fullUrl);
    let body = null;
    if (method === 'get' && params) {
      Object.keys(params).forEach((key) =>
        fullUrl.searchParams.append(key, params[key]),
      );
    } else if (params) {
      if (headers['Content-Type'] === 'application/json') {
        body = typeof params === 'string' ? params : JSON.stringify(params);
      } else if (
        headers['Content-Type'] === 'application/x-www-form-urlencoded'
      ) {
        body = new URLSearchParams(params).toString();
      } else if (headers['Content-Type'] === 'multipart/form-data') {
        body = params;
        delete headers['Content-Type'];
      } else {
        body = params;
      }
    }

    console.log('fastapi 메서드 실행, fullUrl:', fullUrl.toString());
    console.log('Request Headers:', headers);
    console.log('Request Body:', body);

    const fetchOptions = {
      method: method,
      headers: headers,
      body: body,
    };

    const controller = new AbortController();
    const timeoutId = setTimeout(
      () => controller.abort(),
      safeOptions.timeout || 20000,
    );
    fetchOptions.signal = controller.signal;

    try {

      const response = await fetch(fullUrl.toString(), fetchOptions);
      clearTimeout(timeoutId);

      const contentType = response.headers.get('content-type');
      let responseData;
      if (contentType && contentType.indexOf('application/json') !== -1) {
        responseData = await response.json();
      } else if (safeOptions.responseType === 'blob') {
        // 추가
        //responseData = await response.blob();
        responseData = response;
      } else {
        responseData = await response.text();
      }

      if (response.ok) {
        if (typeof success_callback === 'function') {
          success_callback(responseData);
        }
        resolve(responseData);
      } else if (
        response.status === 401 &&
        !options.isRetry &&
        !url.includes('/login') && // 로그인 관련 엔드포인트에서는 토큰 갱신 시도하지 않음
        !url.includes('/refresh') // 토큰 갱신 엔드포인트에서도 재시도하지 않음
      ) {
        if (!isRefreshing) {
          isRefreshing = true;
          try {
            const newToken = await authStore.refreshToken();
            headers['Authorization'] = `Bearer ${newToken}`;
            // 새로운 요청 시도
            const retryResponse = await fastapi(
              operation,
              url,
              params,
              success_callback,
              failure_callback,
              { ...options, isRetry: true }
            );
            processQueue(null, newToken);
            resolve(retryResponse);
            return;
          } catch (error) {
            processQueue(error, null);
            if (typeof failure_callback === 'function') {
              failure_callback(error);
            }
            reject(error);
            return;
          } finally {
            isRefreshing = false;
          }
        }

        // 이미 리프레시가 진행 중이면 큐에 추가
        return new Promise((resolveRetry, rejectRetry) => {
          failedQueue.push({ resolve: resolveRetry, reject: rejectRetry });
        }).then(() => {
          return fastapi(
            operation,
            url,
            params,
            success_callback,
            failure_callback,
            { ...options, isRetry: true }
          );
        });
      } else {
        // 로그인 실패나 토큰 갱신 실패 시에는 토큰 갱신 시도하지 않음
        if (response.status === 401) {
          if (url.includes('/login')) {
            console.log('Login failed with 401 - not attempting token refresh');
          } else if (url.includes('/refresh')) {
            console.log('Token refresh failed with 401 - clearing auth data');
            authStore.clearAuthData();
          }
        }
        
        if (typeof failure_callback === 'function') {
          try {
            failure_callback(responseData);
          } catch (callbackError) {
            console.error('Failure callback error:', callbackError);
          }
        }
        try {
          reject(responseData);
        } catch (rejectError) {
          console.error('Reject error:', rejectError);
        }
      }
    } catch (error) {
      clearTimeout(timeoutId);
      if (error.name === 'AbortError') {
        console.error('API 요청 시간 초과:', error);
        const timeoutError = { error: 'Request timed out' };
        if (typeof failure_callback === 'function') {
          failure_callback(timeoutError);
        }
        reject(timeoutError);
      } else {
        console.error('API 요청 중 오류 발생:', error);
        if (typeof failure_callback === 'function') {
          try {
            failure_callback({ error: error.message });
          } catch (callbackError) {
            console.error('Failure callback error:', callbackError);
          }
        }
        try {
          reject(error);
        } catch (rejectError) {
          console.error('Reject error:', rejectError);
        }
      }

      if (options.retries && options.retries > 0) {
        console.log(`재시도 중... 남은 시도 횟수: ${options.retries}`);
        fastapi(operation, url, params, success_callback, failure_callback, {
          ...options,
          retries: options.retries - 1,
        })
          .then(resolve)
          .catch(reject);
      }
    }
  });
};

// 이미지 업로드를 위한 함수
const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  return new Promise((resolve, reject) => {
    fastapi(
      'post',
      '/api/bbs/upload-image',
      formData,
      (response) => {
        resolve(response);
      },
      (error) => {
        reject(error);
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
  });
};

export { uploadImage };

// import axios from '@/api';
//
// const fastapi2 = async (method, url, params = null, success_callback = null, failure_callback = null, options = {}) => {
//   console.log('fastapi 호출:', {
//     method,
//     url,
//     params,
//     options
//   });
//
//   const axiosConfig = {
//     method: method,
//     url: url,
//     ...options
//   };
//
//   if (method === 'get' || method === 'delete') {
//     axiosConfig.params = params;
//   } else {
//     axiosConfig.data = params;
//   }
//
//   console.log('axios 요청 설정:', axiosConfig);
//
//   try {
//     const response = await axios(axiosConfig);
//     console.log('axios 응답:', {
//       status: response.status,
//       headers: response.headers,
//       data: response.data
//     });
//    
//     if (success_callback) {
//       success_callback(response.data);
//     }
//     return response.data;
//   } catch (error) {
//     console.error('axios 에러:', {
//       config: error.config,
//       response: error.response
//     });
//    
//     if (failure_callback) {
//       failure_callback(error);
//     }
//     throw error;
//   }
// };

// fastapi 함수를 default export로 내보내기
export default fastapi;
